import { FastlyImage } from '@components/common/image'

type LearningCardProps = {
  image: string
  text: string
}

const LearningCard = ({ image, text }: LearningCardProps): JSX.Element => {
  return (
    <div className="relative mx-auto lg:mx-0">
      <FastlyImage
        src={image}
        className="lazyload"
        alt={text}
        width={380}
        height={278}
      />
      <div
        className="absolute text-grey-900 font-700 text-3xl text-center"
        style={{
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
        }}
      >
        {text}
      </div>
    </div>
  )
}

const Learning = (): JSX.Element => (
  <div
    className="relative pb-10 px-10"
    style={{
      WebkitMaskImage:
        'radial-gradient(110% 10% at top, transparent 50%, #fff 50%)',
      maskImage: 'radial-gradient(110% 5% at top, transparent 50%, #fff 50%)',
    }}
  >
    <div className="mx-auto text-center max-w-5xl pt-24">
      <h3 className="text-grey font-700 text-4xl lg:text-5xl text-center leading-tight">
        Our classes, activities, games, quizzes, and projects helps students
        develop all the 4 C&apos;s of learning
      </h3>
    </div>
    <div className="flex flex-col justify-center lg:mt-10 lg:flex-row">
      <LearningCard
        image="/images/curriculum/learning/critical-thinking.svg"
        text="Critical Thinking"
      />
      <LearningCard
        image="/images/curriculum/learning/collaboration.svg"
        text="Collaboration"
      />
      <LearningCard
        image="/images/curriculum/learning/communication.svg"
        text="Communication"
      />
      <LearningCard
        image="/images/curriculum/learning/creativity.svg"
        text="Creativity"
      />
    </div>
  </div>
)

export default Learning
